import {Outlet} from 'react-router-dom'
import React from 'react'
import {Header} from '@components/commons/header/Header.tsx'
import styled from 'styled-components'

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
`

const ContentContainer = styled.div`
    flex: 1;
    overflow: hidden;
`

export const PublicLayout: React.FC = () => {
    return (
        <MainContainer>
            <Header />
            <ContentContainer>
                <Outlet />
            </ContentContainer>
        </MainContainer>
    )
}
